<template>
  <div class="mt-28px">
    <h5 v-if="!!title" class="mb-4"><i class="dot"></i> {{ title }}</h5>

    <table>
      <colgroup>
        <col />
        <col width="120" />
        <col width="120" />
      </colgroup>
      <thead>
        <tr>
          <th>{{ labelHead }}</th>
          <th>{{ maxScoreHead }}</th>
          <th>{{ scoreHead }}</th>
        </tr>
      </thead>
      <tbody v-for="(rows, indexRows) in list">
        <tr v-if="rows.label" class="sction-title">
          <td :colSpan="useSectionScore ? 1 : 3">
            {{ rows.label }}
          </td>
          <td v-if="useSectionScore" class="text-center">{{ sctionMaxScore(rows.childs) }}</td>
          <td v-if="useSectionScore" class="text-center">{{ sctionScore(rows.childs) }}</td>
        </tr>
        <tr v-for="(child, indexChild) in rows.childs">
          <td>{{ child.label }}</td>
          <td class="text-center">{{ child.max }}</td>
          <td style="padding: 7px">
            <span v-if="isPrint" class="print-input">{{ child.value }}</span>
            <number-input v-else :readonly="rows.partReadonly ? partReadonly || readonly : readonly" :align="'left'" v-model="child.value" :min="0" :max="child.max" />
          </td>
        </tr>
      </tbody>
      <tbody>
        <tr class="sction-title">
          <td>{{ labelFooter }}</td>
          <td class="text-center">{{ allScore }}</td>
          <td class="text-center">{{ userScore }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import NumberInput from "@/components/NumberInput.vue";
export default {
  name: "TableInspect",
  components: { NumberInput },
  props: {
    title: String,
    readonly: Boolean,
    partReadonly: Boolean,
    isPrint: Boolean,
    useSectionScore: Boolean,

    labelHead: {
      type: String,
      default: "평가 내용",
    },
    maxScoreHead: {
      type: String,
      default: "배점",
    },
    scoreHead: {
      type: String,
      default: "점수",
    },
    labelFooter: {
      type: String,
      default: "평가 점수",
    },

    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: this.value,
    };
  },
  computed: {
    allScore() {
      if (this.list.length < 1) return 0;
      const _arr = this.list.reduce((prev, item) => {
        return prev.concat(item.childs);
      }, []);

      const allMaxScore = _arr.reduce((score, child) => {
        return score + child.max;
      }, 0);

      return allMaxScore;
    },
    userScore() {
      if (this.list.length < 1) return 0;
      const _arr = this.list.reduce((prev, item) => {
        return prev.concat(item.childs);
      }, []);

      const allValueScore = _arr.reduce((score, child) => {
        return score + Number(child.value);
      }, 0);

      this.$emit("userScore", allValueScore);
      return allValueScore;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    sctionMaxScore(childs) {
      return childs.reduce((prev, curr) => {
        return prev + curr.max;
      }, 0);
    },
    sctionScore(childs) {
      return childs.reduce((prev, curr) => {
        return prev + curr.value;
      }, 0);
    },
    scoreInputFilter(data, child) {
      const inputNum = Number(data.replace(/[^0-9]/g, "").replace(/(\..*)\./g, "$1"));

      if (inputNum < 0) child.value = 0;
      else child.value = child.max < inputNum ? child.max : inputNum;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  &,
  th,
  td {
    border: $border;
  }

  th {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding: 10px 0;

    background: $bg;
  }

  tr.sction-title td {
    font-size: 14px;
    font-weight: 700;
    background: $bg;
    padding: 17px 15px;
  }

  td {
    font-size: 14px;
    font-weight: 400;
    padding: 17px 15px;
  }
}
</style>
